import request from '../tools/request'
import { PromiseResponseData, TableRes } from '../global'
import { getUserId } from '../tools/util'
import { HTTP } from './http'
const { GET, POST, uploadFilePOST, downFilePost } = request

export interface ReportMaterialParams {
  auditEndTime?: number // 审核结束时间
  auditStartTime?: number // 审核开始时间
  auditUserId?: string // 审核人ID
  auditUserName?: string // 审核人名称
  brandName?: string // 品牌名称
  categoryName?: string // 类目名称
  materialCode?: string // 物料编码
  materialName?: string // 物料名称
  pageNo?: number // 当前页码
  pageSize?: number // 分页尺寸
  projectCode?: string // 项目Code
  projectName?: string // 项目名称
  reportCode?: string // 提报流程编码
  reportEndTime?: number // 提报结束时间
  reportStartTime?: number // 提报开始时间
  /**
   * 提报状态 (PENDING_SALES_AUDIT:待销售审核, SALES_AUDITING:销售审核中, PENDING_PUSH:待推送, PUSHED:已推送, REJECTED:已驳回,PASS:审核通过)
   * 提报状态
   */
  reportStatus?: string // 提报状态
  /**
   * 提报类型 (NEW:商品新增, MODIFY:商品修改)
   * 提报类型
   */
  reportType?: string // 提报类型
  schemeId?: string // 搜索方案ID
  /**
   * 数据状态 1-正常 0-删除
   * 数据状态
   */
  state?: string // 数据状态
  supplierId?: string // 供应商ID
  supplierName?: string // 供应商名称
  userId?: string // 用户ID
  [property: string]: any
}
/**
 * 物料提报列表VO
 *
 * MaterialReportListVO
 */
export interface MaterialReportListVO {
  auditRemark?: string // 审核备注
  auditTime?: number // 审核时间
  auditUserId?: string // 审核人ID
  auditUserName?: string // 审核人名称
  id?: string // 主键
  materialCode?: string // 物料编码
  materialName?: string // 物料名称
  projectCode?: string // 项目Code
  projectName?: string // 项目名称
  reportCode?: string // 提报流程编码
  reportStatus?: string // 提报状态
  reportStatusName?: string // 提报状态名称
  reportTime?: number // 提报时间
  reportType?: string // 提报类型
  reportTypeName?: string // 提报类型名称
  supplierName?: string // 供应商名称
  [property: string]: any
}

/**
 * 物料提报日志VO
 *
 * MaterialReportLogVO
 */
export interface MaterialReportLogVO {
  afterStatus?: string // 操作后状态
  afterStatusName?: string // 操作后状态名称
  beforeStatus?: string // 操作前状态
  beforeStatusName?: string // 操作前状态名称
  id?: string // 主键
  operationNode?: string // 操作节点
  operationNodeName?: string // 操作节点名称
  operationTime?: number // 操作时间
  operatorId?: string // 操作人ID
  operatorName?: string // 操作人名称
  remark?: string // 操作备注
  reportId?: string // 物料提报ID
  [property: string]: any
}

/**
 * 结果数据
 *
 * MaterialReportDetailVO
 */
export interface MaterialReportDetailVO {
  attributesJson?: string // 商品属性JSON
  extendedInfoJson?: string // 扩展信息JSON
  productDetailJson?: string // 商品详情JSON
  agreementPrice?: number // 协议价
  auditRemark?: string // 审核备注
  auditTime?: number // 审核时间
  auditUserId?: string // 审核人ID
  auditUserName?: string // 审核人名称
  brandId?: string // 品牌ID
  brandName?: string // 品牌名称
  categoryId?: string // 类目ID
  categoryName?: string // 类目名称
  id?: string // 主键 ID
  materialCode?: string // 物料编码
  materialId?: string // 物料ID
  materialName?: string // 物料名称
  projectCode?: string // 项目Code
  projectName?: string // 项目名称
  reportCode?: string // 提报流程编码
  reportStatus?: string // 提报状态
  reportStatusName?: string // 提报状态名称
  reportTime?: number // 提报时间
  reportType?: string // 提报类型
  reportTypeName?: string // 提报类型名称
  reportingType?: string // 提报类型映射值（直接传给 getReportFieldConfigs）
  supplierId?: string // 供应商ID
  supplierName?: string // 供应商名称
  reportFieldValues?: ReportFieldValueSubmitDTO[] // 提报动态字段已保存值
  [property: string]: any
}

/**
 * MaterialReportUpdateForm
 * 保存参数
 */
export interface MaterialReportUpdateForm {
  attributesJson?: any // 商品属性JSON
  extendedInfoList?: ExtendedInfo[] // 扩展信息JSON
  id: string // 主键
  [property: string]: any
}

export interface ExtendedInfo {
  controlType?: string // 控件类型， 1：单选框 2：复选框 3：下拉框 4：文本框
  fieldKey?: string // 字段的唯一标识符
  fieldMeaning?: string // 字段的含义或描述， 字段含义，1：品牌 2：类目 3：协议价 4 资质图片 wordCode：产品词 specAttributeValueCode：属性值编码
  fieldName?: string // 字段的显示名称
  fieldValue?: string // 字段的值
  fieldValueName?: string // 字段值，表名称
  require?: boolean // 是否必填
  relateField?: string // 关联字段
  relateFieldEnumValue?: string // 关联字段枚举值
  fieldEnumValueList?: { label: string; value: string }[] // 字段枚举值列表
  description?: string // 字段描述
  sort?: number // 排序
  customErrorMsg?: string // 自定义报错文案（校验不通过时优先使用，为空则使用默认报错）
  fieldLength?: number // 字段长度
  numberRange?: string // 数值范围，格式"最小值,最大值"，一侧为空表示不限，如",60"
  [property: string]: any
}

export interface BrandInfoVO {
  brandCode?: string // 品牌编码
  brandName?: string // 品牌名称
  controlledSupplier?: string // 管控的供应商
  isSupply?: string // 是否供货
  state?: string // 状态
  [property: string]: any
}

// 商品分类信息响应对象
export interface CategoryInfoVO {
  code?: string // 分类编码
  id?: string // 分类唯一ID
  level?: number // 分类层级
  name?: string // 分类名称
  parent?: string // 父级分类标识
  parentIdStr?: string // 父级分类ID
  state?: string // 状态
  discountRate?: string // 分类折扣
  [property: string]: any
}

// 获取项目提报动态字段配置请求参数
export interface ReportFieldConfigParams {
  platformCode: string // 平台编码
  reportingType?: string // 提报类型（1-新增 2-修改 3-上下架更新 4-价格更新 5-重推）
}

// 动态字段配置项
export interface ReportFieldConfigVO {
  id?: string // 字段配置ID
  fieldKey?: string // 字段Key
  fieldName?: string // 字段名称
  fieldValue?: string // 字段值
  required?: boolean // 是否必填
  fieldValueName?: string // 字段值展示名称
  controlType?: string // 控件类型：1-数字 2-文本 3-金额 4-时间 5-单选 6-多选
  rangeList?: string[] // 范围列表
  remark?: string // 备注
  fieldMeaning?: string // 字段含义
  relateField?: string // 关联字段
  relateFieldEnumValue?: string // 关联字段枚举值
  fieldEnumValueList?: { label: string; value: string }[] // 字段枚举值列表
  description?: string // 字段描述
  discountRate?: string // 折扣
  controlRuleJson?: string // 控件规则配置JSON
  hasRelateField?: number // 是否启用关联字段：1-是 0-否
  relateFieldKey?: string // 关联字段Key（指向提报商品信息中的字段）
  relateFieldJson?: string // 关联字段规则JSON
  customErrorMsg?: string // 自定义报错文案
  [property: string]: any
}

// 获取项目提报动态字段配置返回结果
export interface ReportFieldConfigResult {
  platformCode?: string // 平台编码
  platformName?: string // 平台名称
  abbreviation?: string // 平台简称
  showDiscountRate?: '1' | '0' // 是否展示折扣率
  fieldKeyAndValue?: ReportFieldConfigVO[] // 动态字段配置列表
  [property: string]: any
}

/**
 * 获取物料提报列表
 * @param params 查询参数
 * @returns 物料提报列表
 */
export const GET_REPORT_MATERIAL_LIST = (params: ReportMaterialParams) =>
  GET<TableRes<MaterialReportListVO[]>>(`${HTTP}/material/report/page`, params)
/**
 * 获取物料提报日志
 * @param reportId 提报ID
 * @param params 查询参数
 * @returns 物料提报日志
 */
export const GET_REPORT_MATERIAL_LOG = (
  reportId: string,
  params: { pageNo: number; pageSize: number },
) =>
  GET<TableRes<MaterialReportLogVO[]>>(
    `${HTTP}/material/report/${reportId}/logs`,
    params,
  )

/**
 * 导出物料提报列表
 * @param params 查询参数
 * @returns 物料提报列表
 */
export const EXPORT_REPORT_MATERIAL_LIST = (params: ReportMaterialParams) =>
  POST(`${HTTP}/material/report/export`, params, 'application/json')

/**
 * 获取物料提报详情
 * @param id 提报ID
 * @returns 物料提报详情
 */
export const GET_REPORT_MATERIAL_DETAIL = (id: string) =>
  GET<PromiseResponseData<MaterialReportDetailVO>>(
    `${HTTP}/material/report/${id}`,
  )

/**
 * 获取物料提报详情
 * @param id 提报ID
 * @returns 物料提报详情
 */
export const POST_SAVE_MATERIAL_REPORT = (params: MaterialReportUpdateForm) =>
  POST(`${HTTP}/material/report/save`, params, 'application/json')

/**
 * 获取物料提报详情
 * @param id 提报ID
 * @returns 物料提报详情
 */
export const POST_SUMBIT_MATERIAL_REPORT = (params: MaterialReportUpdateForm) =>
  POST(`${HTTP}/material/report/submit`, params, 'application/json')

/**
 *  暂存新增类型的提报物料
 * @param params
 * @returns
 */
export const POST_STORAGE_NEW_MATERIAL = (
  params: MaterialReportStorageNewSaveForm,
) =>
  POST(`${HTTP}/material/report/storageNewMaterial`, params, 'application/json')

export interface MaterialReportStorageNewSaveForm {
  storageInfoJson?: string //  暂存信息JSON
  projectCode?: string //  平台编码
  materialCode?: string //  商品编码
}

/**
 * 获取暂存新增类型的提报物料信息
 * @param params 平台编码
 * @returns
 */
export const POST_GET_STORAGE_NEW_MATERIAL = (
  params: MaterialReportStorageNewSaveForm,
) =>
  POST<MaterialReportStorageNewSaveForm>(
    `${HTTP}/material/report/getStorageNewMaterial`,
    params,
    'application/json',
  )

/**
 * 获取品牌信息
 * @param platformCode 平台编码
 * @returns 品牌信息
 */
export const GET_BRAND_INFO = (params: { platformCode: string }) =>
  GET(`${HTTP}/dock/getBrandInfo`, params)

/**
 * 获取类目池
 * @param platformCode 平台编码
 * @returns 类目池
 */
export const GET_CATEGORY_POOL = (params: {
  platformCode: string
  name?: string
}) => GET(`${HTTP}/dock/getCategoryPool`, params)

/**
 * 获取项目字段
 * @param platformCode 平台编码
 * @returns 项目字段
 */
export const GET_PROJECT_FIELD = (params: { platformCode: string }) =>
  GET(`${HTTP}/dock/getProjectField`, params)

/**
 * 获取项目提报动态字段配置
 * @param params 查询参数
 * @returns 动态字段配置
 */
export const GET_REPORT_FIELD_CONFIGS = (params: ReportFieldConfigParams) =>
  GET<PromiseResponseData<ReportFieldConfigResult>>(
    `${HTTP}/material/report/getReportFieldConfigs`,
    params,
  )

// 提报-属性信息
export interface SpecAttributeForScpVo {
  attributeType: string // 属性类型
  isSaleAttribute: string // 是否销售属性
  required: string // 是否必填
  specAttributeCode: string // 属性编码
  specAttributeId: string // 属性ID
  specAttributeName: string // 属性名称
  specAttributeValueForScpVOList?: SpecAttributeValueForScpVO[] // 属性值列表
}

// 提报-属性值信息
export interface SpecAttributeValueForScpVO {
  specAttributeId: string // 属性ID
  specAttributeValueCode: string // 属性值编码
  specAttributeValueId: string // 属性值ID
  specAttributeValueName: string // 属性值名称
  selected?: boolean // 是否绑定
}

export interface ProductWordInfoVO {
  id: string
  wordCode: string
  wordName: string
}
/**
 * 获取对接平台产品词
 * @param params 查询参数
 * @returns 对接平台产品词
 */
export const GET_LIST_WORD = (params: {
  platformCode: string
  categoryCode: string
}) => GET<ProductWordInfoVO[]>(`${HTTP}/material/report/findListWord`, params)

/**
 * 查询规格属性值列表（对接）
 * @param params 查询参数
 * @returns 规格属性值列表
 */
export const GET_SPEC_ATTRIBUTE_VALUE_LIST = (params: {
  platformCode: string
  categoryCode: string
  wordCode: string
  selectedValueCodes?: string[]
}) =>
  POST<SpecAttributeForScpVo[]>(
    `${HTTP}/material/report/findSpecAttributeValueListForScp`,
    params,
    'application/json',
  )

/**
 * 保存规格属性值并返回规格属性值编码（对接）
 * @param params 查询参数
 * @returns 规格属性值编码
 */
export const POST_SAVE_SPEC_ATTRIBUTE_VALUE_AND_RETURN_CODE = (params: {
  platformCode: string
  specAttributeCode: string
  wordCode: string
  specAttributeValueName: string
}) =>
  POST(
    `${HTTP}/material/report/saveSpecAttributeValueAndReturnCode`,
    params,
    'application/json',
  )

/**
 * 校验当前提报类型
 * @param params 查询参数
 * @returns 校验结果
 */
export const GET_CHECK_REPORT_TYPE = (params: {
  platformCode: string
  productCode: string
  reportType: string
}) => GET(`${HTTP}/material/report/checkReportType`, params)

/**
 * 下载资质更新图片模板
 * @param params 查询参数
 * @returns 资质更新图片模板
 */
export const GET_DOWNLOAD_QUALIFICATION_UPDATE_PICTURE_TEMPLATE = (params: {
  productIds: string[]
}) =>
  downFilePost(`${HTTP}/product/downloadQualificationUpdatePictureTemp`, params)

/**
 * 批量更新资质图片
 * @param params 查询参数
 * @returns 批量更新资质图片
 */
export const POST_BATCH_UPDATE_QUALIFICATION_PICTURE = (
  file: any,
  params?: any,
) =>
  uploadFilePOST(`${HTTP}/product/batchUpdateQualificationPicture`, [file], {
    userId: getUserId(),
    ...params,
  })

/**
 * 查询平台项目型字段信息（对接）
 * @param params 查询参数
 * @returns 平台项目型字段信息
 */
export const GET_PROJECT_FIELD_BY_PLATFORM_CODE = (params: {
  platformCode: string
  submitOperateType: string
  productCode: string
}) => GET(`${HTTP}/material/report/getProjectFieldByPlatformCode`, params)

export interface QualityList {
  baseUrl: string // 前缀路径
  id: string // id
  name: string // 附件名
  sourceType: string // 资质图片类型：1：质量标准凭证，2：国际编码凭证，3：涨价函，4：下架说明，5：国网商品截图，6：易派客商品截图，7：报价单，8：商品资质
  url: string // 附件路径
}

// submitNew 动态字段提交项
export interface ReportFieldValueSubmitDTO {
  configId?: string // 字段配置ID（建议优先传）
  fieldKey?: string // 字段Key（configId 缺失时用于兜底匹配）
  fieldValue?: string // 字段值
  fieldValueLabel?: string // 字段值展示文本
}

interface SumbitMaterialReportNewParams {
  projectCode: string // 项目code
  projectName: string // 项目名称
  reportType: string // 提报类型
  extendedInfoList: ExtendedInfo[] // 扩展信息JSON
  reportFieldValues?: ReportFieldValueSubmitDTO[] // 项目提报动态字段值
  //资质图片类文件
  materialAptitudeFileList: QualityList[]
  materialCode: string // 物料编码（商品编码）
  materialId: string // 物料ID
  materialName: string // 物料名称
  supplierId: string // 供应商ID
  supplierName: string // 供应商名称
}
/**
 * 保存并提交物料提报至MPM（新）
 * @param params 查询参数
 * @returns 保存并提交物料提报至MPM（新）
 */
export const POST_SUBMIT_MATERIAL_REPORT_NEW = (
  params: SumbitMaterialReportNewParams,
) => POST(`${HTTP}/material/report/submitNew`, params, 'application/json')

/**
 * 校验规格属性值是否必填
 * @param params 查询参数
 * @returns 校验结果
 */
export const POST_IS_REQUIRED_SPEC_ATTRIBUTE_FOR_SUBMIT = (params: {
  platformCode: string
  categoryCode: string
  wordCode: string
}) =>
  POST(
    `${HTTP}/material/report/isRequiredSpecAttributeForSubmit`,
    params,
    'application/json',
  )

// 获取武汉销售人员列表
export const GET_WUHAN_SALE_PERSON_LIST = () =>
  POST(`${HTTP}/material/report/getWuhanSalePersonList`)

/**
 * 获取管网主数据编码列表
 * @returns 管网主数据编码列表
 */
export const GET_THIRD_PRODUCT_CODE_LIST = (params: {
  platformCode: string
  name?: string
}) => GET(`${HTTP}/material/report/findListStandardMaterial`, params)

// 导出下载客户品牌
export const POST_EXPORT_DOWNLOAD_CUSTOMER_BRAND = (params: {
  platformCode: string
}) => GET(`${HTTP}/material/report/exportDownloadCustomerBrand`, params)
// 导出下载客户类目分类
export const POST_EXPORT_DOWNLOAD_CUSTOMER_CATEGORY = (params: {
  platformCode: string
}) => GET(`${HTTP}/material/report/exportDownloadCustomerCategory`, params)
// 导出下载客户标准库
export const POST_EXPORT_DOWNLOAD_CUSTOMER_STANDARD_LIBRARY = (params: {
  platformCode: string
}) =>
  GET(`${HTTP}/material/report/exportDownloadCustomerStandardLibrary`, params)

// 关联字段计算请求参数
export interface RelateFieldCalcParam {
  platformCode: string // 平台编码
  relateFieldKey: string // 关联字段Key
  relateFieldValue: string // 关联字段值
}

// 关联字段计算结果项
export interface RelateFieldCalcResultItem {
  configId?: string // 字段配置ID
  fieldKey?: string // 字段Key
  fieldName?: string // 字段名称
  calculatedValue?: string // 计算后的值
}

/**
 * 计算关联字段值
 * @param params 关联字段计算参数
 * @returns 计算结果列表
 */
export const POST_CALCULATE_RELATE_FIELD_VALUES = (
  params: RelateFieldCalcParam,
) =>
  POST<PromiseResponseData<RelateFieldCalcResultItem[]>>(
    `${HTTP}/material/report/calculateRelateFieldValues`,
    params,
    'application/json',
  )

//

/** 参与项目类目 AI 推荐的物料快照 */
export interface ProjectCategoryRecommendationMaterial {
  productName: string // 物料名称，缺失时不发起推荐
  brand?: string
  model?: string
  specification?: string
  description?: string
  attributes?: { name?: string; value?: string }[]
}

/** 项目类目 AI 推荐请求参数 */
export interface ProjectCategoryRecommendationParams {
  platformCode: string
  material: ProjectCategoryRecommendationMaterial
  topK?: number // AI 平台约定取值 1~9，不传由服务端取默认值
}

/** 单条项目类目推荐候选 */
export interface ProjectCategoryRecommendationItem {
  categoryCode: string
  leafName: string
  fullPath: string
  confidence: number // 0~1，展示为百分比由前端换算
}

/** 项目类目 AI 推荐结果 */
export interface ProjectCategoryRecommendationResult {
  success?: boolean
  errorCode?: string
  errorMessage?: string
  requestId?: string // 采用推荐时必须原样回传
  recommendations?: ProjectCategoryRecommendationItem[]
}

/** 采用推荐后由服务端回填的类目信息，字段口径与人工选择一致 */
export interface ProjectCategoryAdoptResult {
  categoryCode: string
  leafName: string
  fullPath: string
  discountRate?: string
}

/**
 * 查询平台是否启用项目类目 AI 推荐。平台范围由服务端配置，前端不硬编码。
 */
export const GET_PROJECT_CATEGORY_RECOMMENDATION_ENABLED = (params: {
  platformCode: string
}) =>
  GET<boolean>(
    `${HTTP}/material/report/projectCategoryRecommendation/enabled`,
    params,
  )

/**
 * 请求项目类目 AI 推荐。服务端已按置信度过滤并排序。
 */
export const POST_RECOMMEND_PROJECT_CATEGORY = (
  params: ProjectCategoryRecommendationParams,
) =>
  POST<ProjectCategoryRecommendationResult>(
    `${HTTP}/material/report/projectCategoryRecommendation/recommend`,
    params,
    'application/json',
  )

/**
 * 采用推荐前校验类目仍在当前项目类目池，并取回折扣率等联动字段。
 */
export const POST_ADOPT_PROJECT_CATEGORY = (params: {
  platformCode: string
  requestId: string
  categoryCode: string
}) =>
  POST<ProjectCategoryAdoptResult>(
    `${HTTP}/material/report/projectCategoryRecommendation/adopt`,
    params,
    'application/json',
  )
import request from '../tools/request'
import { PromiseResponseData, TableRes } from '../global'
import { getUserId } from '../tools/util'
import { HTTP } from './http'
const { GET, POST, uploadFilePOST, downFilePost } = request

export interface ReportMaterialParams {
  auditEndTime?: number // 审核结束时间
  auditStartTime?: number // 审核开始时间
  auditUserId?: string // 审核人ID
  auditUserName?: string // 审核人名称
  brandName?: string // 品牌名称
  categoryName?: string // 类目名称
  materialCode?: string // 物料编码
  materialName?: string // 物料名称
  pageNo?: number // 当前页码
  pageSize?: number // 分页尺寸
  projectCode?: string // 项目Code
  projectName?: string // 项目名称
  reportCode?: string // 提报流程编码
  reportEndTime?: number // 提报结束时间
  reportStartTime?: number // 提报开始时间
  /**
   * 提报状态 (PENDING_SALES_AUDIT:待销售审核, SALES_AUDITING:销售审核中, PENDING_PUSH:待推送, PUSHED:已推送, REJECTED:已驳回,PASS:审核通过)
   * 提报状态
   */
  reportStatus?: string // 提报状态
  /**
   * 提报类型 (NEW:商品新增, MODIFY:商品修改)
   * 提报类型
   */
  reportType?: string // 提报类型
  schemeId?: string // 搜索方案ID
  /**
   * 数据状态 1-正常 0-删除
   * 数据状态
   */
  state?: string // 数据状态
  supplierId?: string // 供应商ID
  supplierName?: string // 供应商名称
  userId?: string // 用户ID
  [property: string]: any
}
/**
 * 物料提报列表VO
 *
 * MaterialReportListVO
 */
export interface MaterialReportListVO {
  auditRemark?: string // 审核备注
  auditTime?: number // 审核时间
  auditUserId?: string // 审核人ID
  auditUserName?: string // 审核人名称
  id?: string // 主键
  materialCode?: string // 物料编码
  materialName?: string // 物料名称
  projectCode?: string // 项目Code
  projectName?: string // 项目名称
  reportCode?: string // 提报流程编码
  reportStatus?: string // 提报状态
  reportStatusName?: string // 提报状态名称
  reportTime?: number // 提报时间
  reportType?: string // 提报类型
  reportTypeName?: string // 提报类型名称
  supplierName?: string // 供应商名称
  [property: string]: any
}

/**
 * 物料提报日志VO
 *
 * MaterialReportLogVO
 */
export interface MaterialReportLogVO {
  afterStatus?: string // 操作后状态
  afterStatusName?: string // 操作后状态名称
  beforeStatus?: string // 操作前状态
  beforeStatusName?: string // 操作前状态名称
  id?: string // 主键
  operationNode?: string // 操作节点
  operationNodeName?: string // 操作节点名称
  operationTime?: number // 操作时间
  operatorId?: string // 操作人ID
  operatorName?: string // 操作人名称
  remark?: string // 操作备注
  reportId?: string // 物料提报ID
  [property: string]: any
}

/**
 * 结果数据
 *
 * MaterialReportDetailVO
 */
export interface MaterialReportDetailVO {
  attributesJson?: string // 商品属性JSON
  extendedInfoJson?: string // 扩展信息JSON
  productDetailJson?: string // 商品详情JSON
  agreementPrice?: number // 协议价
  auditRemark?: string // 审核备注
  auditTime?: number // 审核时间
  auditUserId?: string // 审核人ID
  auditUserName?: string // 审核人名称
  brandId?: string // 品牌ID
  brandName?: string // 品牌名称
  categoryId?: string // 类目ID
  categoryName?: string // 类目名称
  id?: string // 主键 ID
  materialCode?: string // 物料编码
  materialId?: string // 物料ID
  materialName?: string // 物料名称
  projectCode?: string // 项目Code
  projectName?: string // 项目名称
  reportCode?: string // 提报流程编码
  reportStatus?: string // 提报状态
  reportStatusName?: string // 提报状态名称
  reportTime?: number // 提报时间
  reportType?: string // 提报类型
  reportTypeName?: string // 提报类型名称
  reportingType?: string // 提报类型映射值（直接传给 getReportFieldConfigs）
  supplierId?: string // 供应商ID
  supplierName?: string // 供应商名称
  reportFieldValues?: ReportFieldValueSubmitDTO[] // 提报动态字段已保存值
  [property: string]: any
}

/**
 * MaterialReportUpdateForm
 * 保存参数
 */
export interface MaterialReportUpdateForm {
  attributesJson?: any // 商品属性JSON
  extendedInfoList?: ExtendedInfo[] // 扩展信息JSON
  id: string // 主键
  [property: string]: any
}

export interface ExtendedInfo {
  controlType?: string // 控件类型， 1：单选框 2：复选框 3：下拉框 4：文本框
  fieldKey?: string // 字段的唯一标识符
  fieldMeaning?: string // 字段的含义或描述， 字段含义，1：品牌 2：类目 3：协议价 4 资质图片 wordCode：产品词 specAttributeValueCode：属性值编码
  fieldName?: string // 字段的显示名称
  fieldValue?: string // 字段的值
  fieldValueName?: string // 字段值，表名称
  require?: boolean // 是否必填
  relateField?: string // 关联字段
  relateFieldEnumValue?: string // 关联字段枚举值
  fieldEnumValueList?: { label: string; value: string }[] // 字段枚举值列表
  description?: string // 字段描述
  sort?: number // 排序
  customErrorMsg?: string // 自定义报错文案（校验不通过时优先使用，为空则使用默认报错）
  fieldLength?: number // 字段长度
  numberRange?: string // 数值范围，格式"最小值,最大值"，一侧为空表示不限，如",60"
  [property: string]: any
}

export interface BrandInfoVO {
  brandCode?: string // 品牌编码
  brandName?: string // 品牌名称
  controlledSupplier?: string // 管控的供应商
  isSupply?: string // 是否供货
  state?: string // 状态
  [property: string]: any
}

// 商品分类信息响应对象
export interface CategoryInfoVO {
  code?: string // 分类编码
  id?: string // 分类唯一ID
  level?: number // 分类层级
  name?: string // 分类名称
  parent?: string // 父级分类标识
  parentIdStr?: string // 父级分类ID
  state?: string // 状态
  discountRate?: string // 分类折扣
  [property: string]: any
}

// 获取项目提报动态字段配置请求参数
export interface ReportFieldConfigParams {
  platformCode: string // 平台编码
  reportingType?: string // 提报类型（1-新增 2-修改 3-上下架更新 4-价格更新 5-重推）
}

// 动态字段配置项
export interface ReportFieldConfigVO {
  id?: string // 字段配置ID
  fieldKey?: string // 字段Key
  fieldName?: string // 字段名称
  fieldValue?: string // 字段值
  required?: boolean // 是否必填
  fieldValueName?: string // 字段值展示名称
  controlType?: string // 控件类型：1-数字 2-文本 3-金额 4-时间 5-单选 6-多选
  rangeList?: string[] // 范围列表
  remark?: string // 备注
  fieldMeaning?: string // 字段含义
  relateField?: string // 关联字段
  relateFieldEnumValue?: string // 关联字段枚举值
  fieldEnumValueList?: { label: string; value: string }[] // 字段枚举值列表
  description?: string // 字段描述
  discountRate?: string // 折扣
  controlRuleJson?: string // 控件规则配置JSON
  hasRelateField?: number // 是否启用关联字段：1-是 0-否
  relateFieldKey?: string // 关联字段Key（指向提报商品信息中的字段）
  relateFieldJson?: string // 关联字段规则JSON
  customErrorMsg?: string // 自定义报错文案
  [property: string]: any
}

// 获取项目提报动态字段配置返回结果
export interface ReportFieldConfigResult {
  platformCode?: string // 平台编码
  platformName?: string // 平台名称
  abbreviation?: string // 平台简称
  showDiscountRate?: '1' | '0' // 是否展示折扣率
  fieldKeyAndValue?: ReportFieldConfigVO[] // 动态字段配置列表
  [property: string]: any
}

/**
 * 获取物料提报列表
 * @param params 查询参数
 * @returns 物料提报列表
 */
export const GET_REPORT_MATERIAL_LIST = (params: ReportMaterialParams) =>
  GET<TableRes<MaterialReportListVO[]>>(`${HTTP}/material/report/page`, params)
/**
 * 获取物料提报日志
 * @param reportId 提报ID
 * @param params 查询参数
 * @returns 物料提报日志
 */
export const GET_REPORT_MATERIAL_LOG = (
  reportId: string,
  params: { pageNo: number; pageSize: number },
) =>
  GET<TableRes<MaterialReportLogVO[]>>(
    `${HTTP}/material/report/${reportId}/logs`,
    params,
  )

/**
 * 导出物料提报列表
 * @param params 查询参数
 * @returns 物料提报列表
 */
export const EXPORT_REPORT_MATERIAL_LIST = (params: ReportMaterialParams) =>
  POST(`${HTTP}/material/report/export`, params, 'application/json')

/**
 * 获取物料提报详情
 * @param id 提报ID
 * @returns 物料提报详情
 */
export const GET_REPORT_MATERIAL_DETAIL = (id: string) =>
  GET<PromiseResponseData<MaterialReportDetailVO>>(
    `${HTTP}/material/report/${id}`,
  )

/**
 * 获取物料提报详情
 * @param id 提报ID
 * @returns 物料提报详情
 */
export const POST_SAVE_MATERIAL_REPORT = (params: MaterialReportUpdateForm) =>
  POST(`${HTTP}/material/report/save`, params, 'application/json')

/**
 * 获取物料提报详情
 * @param id 提报ID
 * @returns 物料提报详情
 */
export const POST_SUMBIT_MATERIAL_REPORT = (params: MaterialReportUpdateForm) =>
  POST(`${HTTP}/material/report/submit`, params, 'application/json')

/**
 *  暂存新增类型的提报物料
 * @param params
 * @returns
 */
export const POST_STORAGE_NEW_MATERIAL = (
  params: MaterialReportStorageNewSaveForm,
) =>
  POST(`${HTTP}/material/report/storageNewMaterial`, params, 'application/json')

export interface MaterialReportStorageNewSaveForm {
  storageInfoJson?: string //  暂存信息JSON
  projectCode?: string //  平台编码
  materialCode?: string //  商品编码
}

/**
 * 获取暂存新增类型的提报物料信息
 * @param params 平台编码
 * @returns
 */
export const POST_GET_STORAGE_NEW_MATERIAL = (
  params: MaterialReportStorageNewSaveForm,
) =>
  POST<MaterialReportStorageNewSaveForm>(
    `${HTTP}/material/report/getStorageNewMaterial`,
    params,
    'application/json',
  )

/**
 * 获取品牌信息
 * @param platformCode 平台编码
 * @returns 品牌信息
 */
export const GET_BRAND_INFO = (params: { platformCode: string }) =>
  GET(`${HTTP}/dock/getBrandInfo`, params)

/**
 * 获取类目池
 * @param platformCode 平台编码
 * @returns 类目池
 */
export const GET_CATEGORY_POOL = (params: {
  platformCode: string
  name?: string
}) => GET(`${HTTP}/dock/getCategoryPool`, params)

/**
 * 获取项目字段
 * @param platformCode 平台编码
 * @returns 项目字段
 */
export const GET_PROJECT_FIELD = (params: { platformCode: string }) =>
  GET(`${HTTP}/dock/getProjectField`, params)

/**
 * 获取项目提报动态字段配置
 * @param params 查询参数
 * @returns 动态字段配置
 */
export const GET_REPORT_FIELD_CONFIGS = (params: ReportFieldConfigParams) =>
  GET<PromiseResponseData<ReportFieldConfigResult>>(
    `${HTTP}/material/report/getReportFieldConfigs`,
    params,
  )

// 提报-属性信息
export interface SpecAttributeForScpVo {
  attributeType: string // 属性类型
  isSaleAttribute: string // 是否销售属性
  required: string // 是否必填
  specAttributeCode: string // 属性编码
  specAttributeId: string // 属性ID
  specAttributeName: string // 属性名称
  specAttributeValueForScpVOList?: SpecAttributeValueForScpVO[] // 属性值列表
}

// 提报-属性值信息
export interface SpecAttributeValueForScpVO {
  specAttributeId: string // 属性ID
  specAttributeValueCode: string // 属性值编码
  specAttributeValueId: string // 属性值ID
  specAttributeValueName: string // 属性值名称
  selected?: boolean // 是否绑定
}

export interface ProductWordInfoVO {
  id: string
  wordCode: string
  wordName: string
}
/**
 * 获取对接平台产品词
 * @param params 查询参数
 * @returns 对接平台产品词
 */
export const GET_LIST_WORD = (params: {
  platformCode: string
  categoryCode: string
}) => GET<ProductWordInfoVO[]>(`${HTTP}/material/report/findListWord`, params)

/**
 * 查询规格属性值列表（对接）
 * @param params 查询参数
 * @returns 规格属性值列表
 */
export const GET_SPEC_ATTRIBUTE_VALUE_LIST = (params: {
  platformCode: string
  categoryCode: string
  wordCode: string
  selectedValueCodes?: string[]
}) =>
  POST<SpecAttributeForScpVo[]>(
    `${HTTP}/material/report/findSpecAttributeValueListForScp`,
    params,
    'application/json',
  )

/**
 * 保存规格属性值并返回规格属性值编码（对接）
 * @param params 查询参数
 * @returns 规格属性值编码
 */
export const POST_SAVE_SPEC_ATTRIBUTE_VALUE_AND_RETURN_CODE = (params: {
  platformCode: string
  specAttributeCode: string
  wordCode: string
  specAttributeValueName: string
}) =>
  POST(
    `${HTTP}/material/report/saveSpecAttributeValueAndReturnCode`,
    params,
    'application/json',
  )

/**
 * 校验当前提报类型
 * @param params 查询参数
 * @returns 校验结果
 */
export const GET_CHECK_REPORT_TYPE = (params: {
  platformCode: string
  productCode: string
  reportType: string
}) => GET(`${HTTP}/material/report/checkReportType`, params)

/**
 * 下载资质更新图片模板
 * @param params 查询参数
 * @returns 资质更新图片模板
 */
export const GET_DOWNLOAD_QUALIFICATION_UPDATE_PICTURE_TEMPLATE = (params: {
  productIds: string[]
}) =>
  downFilePost(`${HTTP}/product/downloadQualificationUpdatePictureTemp`, params)

/**
 * 批量更新资质图片
 * @param params 查询参数
 * @returns 批量更新资质图片
 */
export const POST_BATCH_UPDATE_QUALIFICATION_PICTURE = (
  file: any,
  params?: any,
) =>
  uploadFilePOST(`${HTTP}/product/batchUpdateQualificationPicture`, [file], {
    userId: getUserId(),
    ...params,
  })

/**
 * 查询平台项目型字段信息（对接）
 * @param params 查询参数
 * @returns 平台项目型字段信息
 */
export const GET_PROJECT_FIELD_BY_PLATFORM_CODE = (params: {
  platformCode: string
  submitOperateType: string
  productCode: string
}) => GET(`${HTTP}/material/report/getProjectFieldByPlatformCode`, params)

export interface QualityList {
  baseUrl: string // 前缀路径
  id: string // id
  name: string // 附件名
  sourceType: string // 资质图片类型：1：质量标准凭证，2：国际编码凭证，3：涨价函，4：下架说明，5：国网商品截图，6：易派客商品截图，7：报价单，8：商品资质
  url: string // 附件路径
}

// submitNew 动态字段提交项
export interface ReportFieldValueSubmitDTO {
  configId?: string // 字段配置ID（建议优先传）
  fieldKey?: string // 字段Key（configId 缺失时用于兜底匹配）
  fieldValue?: string // 字段值
  fieldValueLabel?: string // 字段值展示文本
}

interface SumbitMaterialReportNewParams {
  projectCode: string // 项目code
  projectName: string // 项目名称
  reportType: string // 提报类型
  extendedInfoList: ExtendedInfo[] // 扩展信息JSON
  reportFieldValues?: ReportFieldValueSubmitDTO[] // 项目提报动态字段值
  //资质图片类文件
  materialAptitudeFileList: QualityList[]
  materialCode: string // 物料编码（商品编码）
  materialId: string // 物料ID
  materialName: string // 物料名称
  supplierId: string // 供应商ID
  supplierName: string // 供应商名称
}
/**
 * 保存并提交物料提报至MPM（新）
 * @param params 查询参数
 * @returns 保存并提交物料提报至MPM（新）
 */
export const POST_SUBMIT_MATERIAL_REPORT_NEW = (
  params: SumbitMaterialReportNewParams,
) => POST(`${HTTP}/material/report/submitNew`, params, 'application/json')

/**
 * 校验规格属性值是否必填
 * @param params 查询参数
 * @returns 校验结果
 */
export const POST_IS_REQUIRED_SPEC_ATTRIBUTE_FOR_SUBMIT = (params: {
  platformCode: string
  categoryCode: string
  wordCode: string
}) =>
  POST(
    `${HTTP}/material/report/isRequiredSpecAttributeForSubmit`,
    params,
    'application/json',
  )

// 获取武汉销售人员列表
export const GET_WUHAN_SALE_PERSON_LIST = () =>
  POST(`${HTTP}/material/report/getWuhanSalePersonList`)

/**
 * 获取管网主数据编码列表
 * @returns 管网主数据编码列表
 */
export const GET_THIRD_PRODUCT_CODE_LIST = (params: {
  platformCode: string
  name?: string
}) => GET(`${HTTP}/material/report/findListStandardMaterial`, params)

// 导出下载客户品牌
export const POST_EXPORT_DOWNLOAD_CUSTOMER_BRAND = (params: {
  platformCode: string
}) => GET(`${HTTP}/material/report/exportDownloadCustomerBrand`, params)
// 导出下载客户类目分类
export const POST_EXPORT_DOWNLOAD_CUSTOMER_CATEGORY = (params: {
  platformCode: string
}) => GET(`${HTTP}/material/report/exportDownloadCustomerCategory`, params)
// 导出下载客户标准库
export const POST_EXPORT_DOWNLOAD_CUSTOMER_STANDARD_LIBRARY = (params: {
  platformCode: string
}) =>
  GET(`${HTTP}/material/report/exportDownloadCustomerStandardLibrary`, params)

// 关联字段计算请求参数
export interface RelateFieldCalcParam {
  platformCode: string // 平台编码
  relateFieldKey: string // 关联字段Key
  relateFieldValue: string // 关联字段值
}

// 关联字段计算结果项
export interface RelateFieldCalcResultItem {
  configId?: string // 字段配置ID
  fieldKey?: string // 字段Key
  fieldName?: string // 字段名称
  calculatedValue?: string // 计算后的值
}

/**
 * 计算关联字段值
 * @param params 关联字段计算参数
 * @returns 计算结果列表
 */
export const POST_CALCULATE_RELATE_FIELD_VALUES = (
  params: RelateFieldCalcParam,
) =>
  POST<PromiseResponseData<RelateFieldCalcResultItem[]>>(
    `${HTTP}/material/report/calculateRelateFieldValues`,
    params,
    'application/json',
  )

//

/** 参与项目类目 AI 推荐的物料快照 */
export interface ProjectCategoryRecommendationMaterial {
  productName: string // 物料名称，缺失时不发起推荐
  brand?: string
  model?: string
  specification?: string
  description?: string
  attributes?: { name?: string; value?: string }[]
}

/** 项目类目 AI 推荐请求参数 */
export interface ProjectCategoryRecommendationParams {
  platformCode: string
  material: ProjectCategoryRecommendationMaterial
  topK?: number // AI 平台约定取值 1~9，不传由服务端取默认值
}

/** 单条项目类目推荐候选 */
export interface ProjectCategoryRecommendationItem {
  categoryCode: string
  leafName: string
  fullPath: string
  confidence: number // 0~1，展示为百分比由前端换算
}

/** 项目类目 AI 推荐结果 */
export interface ProjectCategoryRecommendationResult {
  success?: boolean
  errorCode?: string
  errorMessage?: string
  requestId?: string // 采用推荐时必须原样回传
  recommendations?: ProjectCategoryRecommendationItem[]
}

/** 采用推荐后由服务端回填的类目信息，字段口径与人工选择一致 */
export interface ProjectCategoryAdoptResult {
  categoryCode: string
  leafName: string
  fullPath: string
  discountRate?: string
}

/**
 * 查询平台是否启用项目类目 AI 推荐。平台范围由服务端配置，前端不硬编码。
 */
export const GET_PROJECT_CATEGORY_RECOMMENDATION_ENABLED = (params: {
  platformCode: string
}) =>
  GET<boolean>(
    `${HTTP}/material/report/projectCategoryRecommendation/enabled`,
    params,
  )

/**
 * 请求项目类目 AI 推荐。服务端已按置信度过滤并排序。
 */
export const POST_RECOMMEND_PROJECT_CATEGORY = (
  params: ProjectCategoryRecommendationParams,
) =>
  POST<ProjectCategoryRecommendationResult>(
    `${HTTP}/material/report/projectCategoryRecommendation/recommend`,
    params,
    'application/json',
  )

/**
 * 采用推荐前校验类目仍在当前项目类目池，并取回折扣率等联动字段。
 */
export const POST_ADOPT_PROJECT_CATEGORY = (params: {
  platformCode: string
  requestId: string
  categoryCode: string
}) =>
  POST<ProjectCategoryAdoptResult>(
    `${HTTP}/material/report/projectCategoryRecommendation/adopt`,
    params,
    'application/json',
  )
